import type { ItemKind } from "@csf/shared";
import { cn } from "../lib/cn.js";
import { kindLabel } from "../lib/format.js";

const KINDS: ItemKind[] = ["sticker", "keychain", "skin"];

interface Props {
  value: ItemKind | "all";
  onChange: (v: ItemKind | "all") => void;
  // Если true — добавляем "Все".
  includeAll?: boolean;
}

export function KindTabs({ value, onChange, includeAll = true }: Props) {
  const items: Array<{ key: ItemKind | "all"; label: string }> = [];
  if (includeAll) items.push({ key: "all", label: "Все" });
  for (const k of KINDS) items.push({ key: k, label: kindLabel(k) });

  return (
    <div className="flex gap-1 rounded-xl bg-bg-secondary p-1">
      {items.map((it) => (
        <button
          key={it.key}
          type="button"
          onClick={() => onChange(it.key)}
          className={cn(
            "flex-1 rounded-lg px-3 py-1.5 text-sm transition",
            value === it.key
              ? "bg-bg text-text font-medium shadow-sm"
              : "text-hint hover:text-text",
          )}
        >
          {it.label}
        </button>
      ))}
    </div>
  );
}
